module.exports = __webpack_public_path__ + "static/media/nHomeIcon.d52b77e8.svg";